module.exports = __webpack_public_path__ + "static/media/temperature_icon.448372b3.svg";